import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import type { Trip, TravelPartyMember } from "../types";

/**
 * The trip's travel party, for pages below the trip that only need the roster.
 *
 * A segment page shows "who was there" chips but has no other reason to hold
 * the whole trip document; an empty map (while loading, or for a trip with no
 * party recorded) simply hides the picker.
 */
export function useTravelParty(tripId: string | undefined): Record<string, TravelPartyMember> {
  const [party, setParty] = useState<Record<string, TravelPartyMember>>({});

  useEffect(() => {
    if (!tripId) {
      setParty({});
      return;
    }
    let cancelled = false;
    getDoc(doc(db, "trips", tripId))
      .then((snap) => {
        if (cancelled) return;
        setParty(snap.exists() ? ((snap.data() as Trip).travelParty ?? {}) : {});
      })
      .catch(() => {
        if (!cancelled) setParty({});
      });
    return () => {
      cancelled = true;
    };
  }, [tripId]);

  return party;
}
